





































import { ObjectFactory } from '@/config/objectFactory';
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class DocumentModal extends Vue {
    private show = false;
    private iCacheService = ObjectFactory.getCacheService();
    private sessionInfo = this.iCacheService.getSessionInfo();
    private mounted() {
      this.show = true;
    }
    private close() {
      this.$emit('close');
    }
    get isTransporter() {
      return this.sessionInfo.scopes.includes('transporter');
    }

    get isHomeHealthCare() {
      return this.sessionInfo.scopes.includes('homeHealthCare');
    }
}
